import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { ExpandableContent } from '@kanda-libs/ks-design-library';

import Address from 'components/shared/Address';
import Profile from 'components/shared/Profile';
import { selectors } from 'store';

import { formatAddress } from './helpers';

const PartnerProfile: FunctionComponent = function () {
  const partner = useSelector(selectors.partner.getEntity);

  return (
    <ExpandableContent
      showLabel="Show partner details"
      hideLabel="Hide partner details"
    >
      <Profile.Section title="Contact info">
        <Profile.Property
          label="Name"
          value={partner?.contact_info.contact_name}
        />
        <Profile.Property
          label="Email"
          value={partner?.contact_info.contact_email}
        />
        <Profile.Property
          label="Trading name"
          value={partner?.contact_info.trading_name}
        />
        {partner?.contact_info.contact_address ? (
          <Profile.Property
            label="Address"
            value={
              <>
                <Address address={formatAddress(partner)} />
              </>
            }
          />
        ) : (
          <></>
        )}
        <Profile.Property
          label="Partner emails"
          value={partner?.emails?.join(', ')}
        />
      </Profile.Section>
    </ExpandableContent>
  );
};

export default PartnerProfile;
